import { createSlice } from "@reduxjs/toolkit";

const initialBans =
  !!sessionStorage && sessionStorage.getItem("bans")
    ? JSON.parse(sessionStorage.getItem("bans"))
    : { reasons: [], periods: [] };

const slice = createSlice({
  name: "bans",
  initialState: {
    bans: initialBans,
  },
  reducers: {
    loadPeriodsSuccess: (state, action) => {
      const { payload } = action;
      state.bans = {
        ...state.bans,
        periods: [...payload],
      };
      if (!!sessionStorage) sessionStorage.setItem("bans", JSON.stringify(state.bans));
    },
    loadReasonsSuccess: (state, action) => {
      const { payload } = action;
      state.bans = {
        ...state.bans,
        reasons: [...payload],
      };
      if (!!sessionStorage) sessionStorage.setItem("bans", JSON.stringify(state.bans));
    },
    removeBansOnLogoutSuccess: (state) => {
      state.bans = { reasons: [], periods: [] };
      if (!!sessionStorage) sessionStorage.removeItem("bans");
    },
  },
});

export const loadPeriods = (data) => async (dispatch) => {
  try {
    dispatch(loadPeriodsSuccess(data));
  } catch (e) {
    return console.error(e.message);
  }
};

export const loadReasons = (data) => async (dispatch) => {
  try {
    dispatch(loadReasonsSuccess(data));
  } catch (e) {
    return console.error(e.message);
  }
};

export const removeBansOnLogout = async (dispatch) => {
  try {
    dispatch(removeBansOnLogoutSuccess());
  } catch (e) {
    return console.error(e.message);
  }
};

const { actions, reducer } = slice;

export const { loadPeriodsSuccess, loadReasonsSuccess, removeBansOnLogoutSuccess } = actions;

export default reducer;
